<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '运维公司编辑' : '运维公司创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="运维公司名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="运维公司负责人" prop="manager">
        <a-input v-model="form.manager" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="运维公司负责人联系电话" prop="phoneNumber">
        <a-input v-model="form.phoneNumber" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getOperationCompany,
  updateOperationCompany,
  createOperationCompany
} from '@/api/inventory.js'

export default {
  name: 'InputDrawer',
  data () {
    return {
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        name: '',
        manager: '',
        phoneNumber: ''
      },
      rules: {
        name: [
          {
            message: '请输入名称',
            required: true,
            trigger: 'blur'
          }
        ],
        manager: [
          {
            message: '请输入联系人',
            required: true,
            trigger: 'blur'
          }
        ],
        phone_number: [
          {
            message: '请输入联系电话',
            required: true,
            trigger: 'blur'
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    show (id) {
      if (id) {
        this.isUpdate = true
        getOperationCompany(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              name: data.name,
              manager: data.manager,
              phoneNumber: data.phone_number
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        name: '',
        manager: '',
        phoneNumber: ''
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name,
            manager: this.form.manager,
            phone_number: this.form.phoneNumber
          }
          if (this.isUpdate) {
            updateOperationCompany(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createOperationCompany(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
